import { render, staticRenderFns } from "./MatchupBracketMobile.vue?vue&type=template&id=523eac32&scoped=true&"
import script from "./MatchupBracketMobile.vue?vue&type=script&lang=js&"
export * from "./MatchupBracketMobile.vue?vue&type=script&lang=js&"
import style0 from "./MatchupBracketMobile.vue?vue&type=style&index=0&id=523eac32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523eac32",
  null
  
)

export default component.exports